<div class="body-2" [ngStyle]="asignaEstiloBody()">
    <div class="sign-up-wrap smallw">
        <img [src]="srcLogo" alt="" class="logoIngreso" style="height:67px"> 
        <h4 class="colortituloingreso">Cambiar el password</h4>
        <p><br></p>
        <div class="w-form">
            <form [formGroup]="formCambioPwd" (ngSubmit)="cambioPwdSubmit()" #cambioPwdForm="ngForm"
                id="cambioPwd-form" name="cambioPwd-form" data-name="Formulario de CambioPwd">

                <small class="form-text text-muted">
                    <a class="colortextoingreso">Ingrese su e-mail</a>
                </small>
                <input type="email" formControlName="fTxtMail" [ngStyle]="asignaEstilo(formCambioPwd, 'fTxtMail')" 
                    name="fTxtMail" data-name="fTxtMail" id="fTxtMail" required=""
                    placeholder="e-mail" class="text_field w-input" minlength="5" maxlength="256" #spy>
                <!-- <br>spy es un truco para ver datos de un elemento, como: {{spy.className}} -->
                <p class="form-text text-muted">
                    <a class="colortextoingreso">Al presionar Enviar Mail, enviaremos un mensaje con un enlace que permitirá cambiar el password</a>
                </p>

                <div class="columns-7 w-row">
                    <div class="w-col w-col-6">
                        <input type="submit" [disabled]="!formCambioPwd.valid" [ngStyle]="asignaEstiloSubmitDisabled(formCambioPwd)" value="Enviar Mail" data-wait="Un momento, por favor..." id="fBtnIngresar" class="button w-button">
                    </div>
                    <div class="w-col w-col-6">
                        <input type="submit" routerLink="/sitio-publico/inicio" value="Salir" data-wait="Un momento, por favor..." id="fBtnSalir" class="button w-button">
                    </div>
                </div>
                <h4 *ngIf="mensajeLogin!==''">{{mensajeLogin}}</h4>
                <h4 *ngIf="mensajeLogin2!==''">{{mensajeLogin2}}</h4>
            </form>
        </div>
    </div>
</div>
